import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  abilities: service(),
  navbarSettings: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('admin_edit_funds')) {
      transition.abort();
      return;
    }
    set(this, 'navbarSettings.title', 'Delete Fund');
  },
});
